var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('h1',[_vm._v("Désolé")]),_c('p',[_vm._v("La page que vous recherchez semble introuvable.")]),_c('p',[_vm._v("Code d'erreur: 404")]),_c('router-link',{attrs:{"to":{
        name: 'home'
      }}},[_c('b-button',{staticClass:"w-25 btn-fleche",attrs:{"variant":"primary"}},[_c('span',[_c('b-icon-arrow-right',{attrs:{"aria-hidden":"true"}}),_vm._v(" Retour à l'accueil ")],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }